// reducer.js
import { SET_FINAL_WORK_ORDER_JSON } from '../actions/assetActions';

const initialState = {
  sections: [
    { title: 'Work Order Report', data: [
      ["Computer Work Order No.(Auto)", ""],
      ["Hospital",""],
      ["Work Order Date", ""],
      ["Asset No", ""],
      ["Description", ""],
      ["Location", ""],
      ["Work Group", ],
      ["Work Group Description", ""]
    ]},
  { title: 'Work Order Receipt and Classification', data: [
      ["Category", ""],
      ["Type", ""],
      ["Priority", ""]
    ]},
  { title: 'Assessment', data: [
      ["Responded By", ""],
      ["Respond Start Date/Time", ""],
      ["Respond Finding","" ],
      ["Respond Type",""  ],
      ["Designation",""],
      ["Respond End Date/Time", ""],
      ["Task Code", ""]
    ]},
  { title: 'Repair Details', data: [
      ["Employee Details", ""],
      ["Flag", ""],
      ["PIC",""],
      ["Activity", ""],
      ["Start Date / Time", ""],
      ["End Date / Time", ""],
      ["Repair Duration", ""],
      ["Remarks", ""],
      ["Preparation Hours", ""],
      ["Verification Hours",""]
    ]},
  { title: 'Part Replacement', data: [
      ["Item/Part Code", ""],
      ["Item Description",""],
      ["Quantity Used", ""]
    ]},
  { title: 'Unscheduled Work Carried Out By', data: [
    ["Employee Name", ""],
      ["Employee ID", ""],
      ["Start Date / Time", "" ],
      ["End Date / Time", ""],
      ["Repair Hours","" ]

  ]},
  { title: 'Spare Parts Used', data: [
    ["Part No", ""],
    ["Part Description", ""],
    ["Item No. (Item Description)", ""],
    ["Quantity", ""],
    ["Cost (RM)", ""],

  ]},

  { title: 'Cost Details', data: [
      ["Breakdown Cost","" ],
      ["PO Number",  "" ],
        ["PPM Cost","" ], 
          ["PPM PO Number", ""],
      ["PPM Cost by Contract",""],
      ["Contract Reference Number",""],
      ["Spare Parts Cost","" ],
      ["Total WO Cost",    "" ]
  ]},
  { title: 'Completion Details', data: [
      ["Root Cause", ""],
      ["Start Date/Time", ""],
      ["Accepted By", ""],
      ["Designation", ""],
      ["Action Taken", ""],
      ["End Date/Time", ""],
      ["Asset Required but not Available", ""]
    ]}
  ],
};

const workOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FINAL_WORK_ORDER_JSON:
      return {
        ...state,
        sections: action.payload,
      };
    default:
      return state;
  }
};

export default workOrderReducer;
